import { Box, styled } from "@mui/material";

export const StyledGallery = styled(Box)(({ theme }) => ({
  ".header": {
    height: "20rem",
    background: theme.color.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    h1: {
      color: theme.color.background,
    },
  },
  ".content": {
    padding: "2rem 10rem",
    ".filterBar": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      paddingBlock: "2rem",
    },
    ".gallery": {
      display: "flex",
      width: "fit-content",
      flexWrap: "wrap",
      gap: "2rem",
      justifyContent: "center",
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.mobile}px)`]: {
    ".header": {
      height: "25vh",
    },
    ".content": {
      padding: "0rem 1rem",
      ".filterBar": {
        paddingBlock: "1rem",
        ".filters": {
          display: "flex",
          flexWrap: "wrap",
          gap: "1rem",
          alignItems: "center",
          justifyContent: "center",
          ".filter": {
            border: `2px solid ${theme.color.main}`,
            borderRadius: "10px",
          },
        },
      },
    },
  },
}));
